var exports = {
  "k": "x127c5a35--0efc1c--container",
};

module.exports = exports;
